// Build a `receipt` object (consumed by receiptPrinter / ReceiptModal) from an
// existing ledger transaction so any chip or credit entry can be re-printed.
// Reprints are marked (`reprint: true`) and fall back to the banker's name for
// the cashier line since we don't re-collect a PIN.

export function buildChipReprintReceipt(tx, { playerName, memberNumber } = {}) {
  return {
    type: tx.entryType === 'deposit' ? 'deposit' : 'redemption',
    reference: tx.id,
    dateTime: tx.createdAt,
    playerName: playerName || 'Player',
    memberNumber: memberNumber || null,
    amountCents: tx.amountCents,
    balanceAfterCents: tx.balanceAfterCents,
    cashierName: tx.banker?.name || null,
    reprint: true,
  };
}

export function buildCreditReprintReceipt(
  tx,
  { playerName, memberNumber, creditLimitCents } = {}
) {
  const owedAfter = Number(tx.balanceAfterCents || 0);
  const limit = Number(creditLimitCents || 0);
  return {
    type: tx.entryType === 'draw' ? 'credit_draw' : 'credit_payment',
    reference: tx.id,
    dateTime: tx.createdAt,
    playerName: playerName || 'Player',
    memberNumber: memberNumber || null,
    amountCents: tx.amountCents,
    balanceOwedCents: owedAfter,
    availableCreditCents: Math.max(limit - owedAfter, 0),
    cashierName: tx.banker?.name || null,
    reprint: true,
  };
}

// Which entry types have a printable receipt (the ones the cage prints at the
// time of the transaction). Others (adjustments, voids, write-offs) are hidden.
export const REPRINTABLE_CHIP = new Set(['deposit', 'redeem']);
export const REPRINTABLE_CREDIT = new Set(['draw', 'payment']);
